import React, { useState, useContext, useLayoutEffect } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { Link, ItemDataRedirect } from 'types/InputVerticalRedirectLinkProps';
import SimpleInput from 'components/SimpleInput';
import { verifyIfFormCanSave } from './functions';
import SystemNotifyContext from 'context/SystemNotifyContext';
import InputColor from 'components/InputColor';
import InputImgBigger from 'components/InputImgBigger';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { generateUid } from 'utils/functions';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import AddBtn from 'components/AddBtn';
import FormAddDataRedirectVerticalRedirectableLink from 'components/FormAddDataRedirectVerticalRedirectableLink';

interface FormAddVerticalRedirectableLinkProps {
	linkToEdit: null | Link;
	isOpen: boolean;
	functionToGetDataAboutLink: any;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	optionsDynamicScreen: SelectInputItemProps[];
}

const initialState: Link = {
	idFront: '',
	name: '',
	text_color: '#000',
	image: {
		id: '',
		path: ''
	},
	redirect: { type: '', value: '' },
	data_redirect: []
};

export default function FormAddVerticalRedirectableLink({
	linkToEdit,
	isOpen,
	functionToGetDataAboutLink,
	setIsOpen,
	optionsDynamicScreen
}: FormAddVerticalRedirectableLinkProps) {
	initialState.idFront = generateUid();

	const { handleNotify } = useContext(SystemNotifyContext);

	const [link, setLink] = useState<Link>(initialState);

	const [isOpenDataRedirect, setIsOpenDataRedirect] = useState(false);

	function saveBanner() {
		const canSave = verifyIfFormCanSave(link, handleNotify);

		if (canSave) {
			functionToGetDataAboutLink(link);
			setIsOpen(false);
			setLink(initialState);
		}
	}

	function cancel() {
		setIsOpen(false);
		setLink(initialState);
	}

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function saveDataRedirectList(list: ItemDataRedirect[]) {
		setLink((obj) => ({ ...obj, data_redirect: [...list] }));
	}

	useLayoutEffect(() => {
		if (linkToEdit !== null) {
			setTimeout(() => {
				setLink(linkToEdit);
			}, 100);
		}
	}, []);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
				setLink(initialState);
			}}
			title={link === null ? 'Adicionar Link' : 'Editar Link'}
			buttonClose={false}
		>
			<S.container>
				<S.twoInputs>
					<SimpleInput
						label="Nome"
						initialValue={link.name}
						getValue={(value: string) => {
							setLink((obj) => ({ ...obj, name: value }));
						}}
					/>

					<InputColor
						label="Cor do texto"
						rgbOrExadecimal={false}
						value={link.text_color}
						setValue={(value: string) => {
							setLink((obj) => ({ ...obj, text_color: value }));
						}}
					/>
				</S.twoInputs>

				<S.twoInputs>
					<SelectInput
						list={optionsRedirectType}
						getValue={(value: SelectInputItemProps | '') => {
							setLink((obj) => ({
								...obj,
								redirect: {
									...obj.redirect,
									type: value === '' ? value : (value?.id as string)
								}
							}));
						}}
						initialValue={
							link.redirect.type === ''
								? optionsRedirectType[0]
								: findOptionOnListById(
										link.redirect.type || '',
										optionsRedirectType
									)
						}
						label="Tipo de redirecionamento *"
					/>

					{(link.redirect.type === '' ||
						link.redirect.type === 'product' ||
						link.redirect.type === 'url' ||
						link.redirect.type === 'webview' ||
						link.redirect.type === 'query' ||
						link.redirect.type === 'screen_app') && (
						<SimpleInput
							label="Valor do redirecionamento *"
							initialValue={link.redirect.value}
							getValue={(value: string) => {
								setLink((obj) => ({
									...obj,
									redirect: { ...obj.redirect, value: value }
								}));
							}}
						/>
					)}

					{link.redirect.type === 'app_screen' && (
						<SelectInput
							list={optionsDynamicScreen}
							getValue={(value: SelectInputItemProps | '') => {
								setLink((obj) => ({
									...obj,
									redirect: {
										...obj.redirect,
										value: value === '' ? value : (value?.id as string)
									}
								}));
							}}
							initialValue={
								link.redirect.value === ''
									? ''
									: findOptionOnListById(
											link.redirect.value || '',
											optionsDynamicScreen
										)
							}
							label="Valor redirecionamento *"
						/>
					)}
				</S.twoInputs>

				<InputImgBigger
					label="Banner"
					idImagem="FormAddBanner"
					initialImage={link.image.id === '' ? '' : `${link.image.path}`}
					getImage={(value: any) => {
						setLink((obj) => {
							return {
								...obj,
								image: {
									id: value?.id || generateUid(),
									path: value?.url || value.relativePath || ''
								}
							};
						});
					}}
				/>

				<AddBtn
					anyFunction={() => {
						setIsOpenDataRedirect(true);
					}}
					text="Adicionar dado de redirecionamento"
				/>

				<S.qtdData>
					Quantidade de dados de redirecionamento: {link.data_redirect.length}
				</S.qtdData>

				{isOpenDataRedirect && (
					<FormAddDataRedirectVerticalRedirectableLink
						isOpen={isOpenDataRedirect}
						setIsOpen={setIsOpenDataRedirect}
						functionToGetDataAboutDataRedirect={saveDataRedirectList}
						link={link}
					/>
				)}

				<S.containerBtns>
					<S.cancel onClick={cancel}>Cancelar</S.cancel>
					<S.save onClick={saveBanner}>Salvar</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
